import type { OilViscosityParameters } from "../../d";

// returns mu_o cP
export function deadOilViscosityCalculator(params: OilViscosityParameters): {
  deadOilViscosity: number;
  deadOilViscosityAPIGt_31: number;
  deadOilViscosity22_31: number;
  deadOilViscosity10_22: number;
  deadOilViscosityLt_10: number;
} {
  const { oilAPI, temperatureF } = params;

  // Q50: =10**(10**(1.67083-0.017628*D7-0.61304*LOG10(D4)))-1
  const deadOilViscosityAPIGt_31 =
    10 **
      (10 **
        (1.67083 - 0.017628 * oilAPI - 0.61304 * Math.log10(temperatureF))) -
    1;
  // Q52: =220.15*10**9*D4**-3.556*(LOG10(D7))**(12.5428*LOG10(D4)-45.7874)
  const deadOilViscosity22_31 =
    220.15 *
    10 ** 9 *
    temperatureF ** -3.556 *
    Math.log10(oilAPI) ** (12.5428 * Math.log10(temperatureF) - 45.7874);
  // Q54: =10**(10**(2.06492-(0.0179*D7)-(0.70226*LOG10(D4))))-1
  const deadOilViscosity10_22 =
    10 **
      (10 ** (2.06492 - 0.0179 * oilAPI - 0.70226 * Math.log10(temperatureF))) -
    1;
  // Q56: =10**(10**(1.90296-(0.012619*D7)-(0.61748*LOG10(D4))))-1
  const deadOilViscosityLt_10 =
    10 **
      (10 **
        (1.90296 - 0.012619 * oilAPI - 0.61748 * Math.log10(temperatureF))) -
    1;

  let deadOilViscosity = 0;
  if (oilAPI > 31.1) {
    deadOilViscosity = deadOilViscosityAPIGt_31;
  } else if (oilAPI > 22.3 && oilAPI <= 31.1) {
    deadOilViscosity = deadOilViscosity22_31;
  } else if (oilAPI > 10 && oilAPI <= 22.3) {
    deadOilViscosity = deadOilViscosity10_22;
  } else if (oilAPI <= 10) {
    deadOilViscosity = deadOilViscosityLt_10;
  }
  return {
    deadOilViscosity,
    deadOilViscosityAPIGt_31,
    deadOilViscosity22_31,
    deadOilViscosity10_22,
    deadOilViscosityLt_10
  };
}
